import { render, staticRenderFns } from "./ProductDataLimitedSubscription.vue?vue&type=template&id=c9f98a04&"
import script from "./ProductDataLimitedSubscription.vue?vue&type=script&lang=js&"
export * from "./ProductDataLimitedSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports